import { LPWysiwygField } from '@/types/landingPages';
import css from './Wysiwyg.module.scss';

const Wysiwyg = ({ content }: LPWysiwygField) => (
  <div dangerouslySetInnerHTML={{ __html: content }} className={css.content}></div>
);

export default Wysiwyg;
